import { createActions } from '../../utils/redux/index';
import consts from './constants';

export { consts };
export default createActions(consts);



// WEBPACK FOOTER //
// ./src/redux/chatConnection/actions.js